import { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import SearchBar from '@/components/feature/SearchBar';
import { categoryMeta } from '@/mocks/resources';

const navItems = [
  { to: '/', label: '首页' },
  { to: '/search', label: '搜索' },
  { to: '/about', label: '关于' },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:h-[72px] md:px-8">
        <Link
          to="/"
          className="flex shrink-0 cursor-pointer items-center gap-2.5"
          title="国语对白做受69 首页"
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-play-circle-fill text-2xl" />
          </span>
          <span className="flex flex-col leading-tight">
            <span className="whitespace-nowrap font-heading text-base font-bold text-foreground-950">
              国语对白做受69
            </span>
            <span className="whitespace-nowrap text-[11px] font-label text-foreground-600">
              高清影音资源集锦
            </span>
          </span>
        </Link>

        <nav className="ml-4 hidden items-center gap-1 md:flex">
          <NavLink
            to="/"
            className={({ isActive }) =>
              `flex h-9 items-center rounded-md px-3 text-sm font-label transition-colors ${
                isActive
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-800 hover:bg-background-100'
              }`
            }
          >
            首页
          </NavLink>

          <div
            className="relative"
            onMouseEnter={() => setCategoryOpen(true)}
            onMouseLeave={() => setCategoryOpen(false)}
          >
            <button
              type="button"
              onClick={() => setCategoryOpen((v) => !v)}
              className={`flex h-9 items-center gap-1 rounded-md px-3 text-sm font-label transition-colors ${
                location.pathname.startsWith('/category')
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-800 hover:bg-background-100'
              }`}
            >
              分类
              <i
                className={`ri-arrow-down-s-line text-base transition-transform ${
                  categoryOpen ? 'rotate-180' : ''
                }`}
              />
            </button>
            {categoryOpen && (
              <div className="absolute left-0 top-full w-64 pt-2">
                <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50 p-1.5">
                  {categoryMeta.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      onClick={() => setCategoryOpen(false)}
                      className="flex items-start gap-3 rounded-md px-3 py-2.5 transition-colors hover:bg-background-100"
                    >
                      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                        <i className={`${cat.icon} text-lg`} />
                      </span>
                      <span className="min-w-0">
                        <span className="block text-sm font-medium text-foreground-950">
                          {cat.name}
                        </span>
                        <span className="block truncate text-xs text-foreground-600">
                          {cat.desc}
                        </span>
                      </span>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>

          {navItems.slice(1).map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `flex h-9 items-center rounded-md px-3 text-sm font-label transition-colors ${
                  isActive
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-800 hover:bg-background-100'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden w-72 lg:block xl:w-80">
          <SearchBar />
        </div>

        <button
          type="button"
          onClick={() => setMobileOpen(true)}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 transition-colors hover:bg-background-100 md:hidden"
          aria-label="打开菜单"
        >
          <i className="ri-menu-2-line text-2xl" />
        </button>
      </div>

      {mobileOpen && (
        <div className="fixed inset-0 z-[60] md:hidden">
          <div
            className="absolute inset-0 bg-foreground-950/50"
            onClick={() => setMobileOpen(false)}
          />
          <div className="absolute right-0 top-0 h-full w-[82%] max-w-sm overflow-y-auto bg-background-50 p-5">
            <div className="mb-5 flex items-center justify-between">
              <span className="font-heading text-base font-bold text-foreground-950">
                国语对白做受69
              </span>
              <button
                type="button"
                onClick={() => setMobileOpen(false)}
                className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100"
                aria-label="关闭菜单"
              >
                <i className="ri-close-line text-2xl" />
              </button>
            </div>

            <div className="mb-5">
              <SearchBar />
            </div>

            <nav className="flex flex-col gap-1">
              <Link
                to="/"
                onClick={() => setMobileOpen(false)}
                className="flex h-11 items-center rounded-md px-3 text-sm font-label text-foreground-900 hover:bg-background-100"
              >
                首页
              </Link>
            </nav>

            <p className="mt-5 mb-2 px-3 text-xs font-label text-foreground-600">
              内容分类
            </p>
            <div className="flex flex-col gap-1">
              {categoryMeta.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  onClick={() => setMobileOpen(false)}
                  className="flex items-center gap-3 rounded-md px-3 py-2.5 text-sm text-foreground-900 hover:bg-background-100"
                >
                  <i className={`${cat.icon} text-primary-600`} />
                  {cat.name}
                  <i className="ri-arrow-right-s-line ml-auto text-foreground-500" />
                </Link>
              ))}
            </div>

            <nav className="mt-5 flex flex-col gap-1 border-t border-background-200 pt-5">
              {navItems.slice(1).map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setMobileOpen(false)}
                  className="flex h-11 items-center rounded-md px-3 text-sm font-label text-foreground-900 hover:bg-background-100"
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}